/* vc-motion.js: homepage store map (vc-store-map) and rewards points slider (vce-rewards).
   Built 2026-10-13. Loaded deferred by both sections; the guard keeps it to one run. */
(function () {
  if (window.__vcMotion) return;
  window.__vcMotion = true;

  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NBSP = '\u00a0';
  var TXT = {
    en: { today: 'Today: ', closed: 'Closed today', to: ' to ', from: function (km, n) { return km + ' km from ' + n; },
          away: function (km) { return km + ' km away'; }, link: 'Store page and directions' },
    fr: { today: "Aujourd'hui" + NBSP + ': ', closed: "Fermé aujourd'hui", to: ' à ', from: function (km, n) { return 'à ' + km + ' km ' + (/^[aeiouéèêîô]/i.test(n) ? "d'" : 'de ') + n; },
          away: function (km) { return 'à ' + km + ' km de vous'; }, link: 'Page du magasin et itinéraire' }
  };

  function tween(from, to, ms, fn) {
    if (RM || from === to || !window.requestAnimationFrame) { fn(to); return; }
    var t0 = performance.now();
    (function step(t) {
      var k = Math.min(1, (t - t0) / ms), e = 1 - Math.pow(1 - k, 3);
      fn(from + (to - from) * e);
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }
  function onView(el, cb) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (es) {
      if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); cb(); }
    }, { threshold: 0.25 });
    io.observe(el);
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- store map ---------- */
  function initMap(sec) {
    if (sec.__vc) return;
    sec.__vc = true;
    var dataEl = sec.querySelector('[data-vcsm-data]');
    if (!dataEl) return;
    var stores = JSON.parse(dataEl.textContent).stores;
    var fr = sec.getAttribute('data-locale') === 'fr', T = fr ? TXT.fr : TXT.en;
    var root = sec.getAttribute('data-root') || '';
    var map = sec.querySelector('.vcsm__map'), tip = sec.querySelector('.vcsm__tip');
    var card = sec.querySelector('[data-vcsm-card]'), chips = sec.querySelectorAll('.vcsm__chip');
    var pins = sec.querySelectorAll('.vcsm__st');

    // entrance: hide pins only once JS is running, then draw them in when the map is on screen
    var num = sec.querySelector('[data-vc-count]');
    if (!RM) sec.classList.add('vc-anim');
    onView(sec, function () {
      sec.classList.add('is-in');
      if (num) { var n = +num.getAttribute('data-vc-count'); tween(0, n, 1300, function (v) { num.textContent = Math.round(v); }); }
    });

    function hav(a, b, c, d) {
      var r = Math.PI / 180, x = Math.pow(Math.sin((c - a) * r / 2), 2) + Math.cos(a * r) * Math.cos(c * r) * Math.pow(Math.sin((d - b) * r / 2), 2);
      return 12742 * Math.asin(Math.sqrt(x));
    }
    function fmtTime(t) {
      var p = t.split(':'), h = +p[0], m = +p[1];
      if (fr) return h + NBSP + 'h' + (m ? NBSP + (m < 10 ? '0' : '') + m : '');
      var ap = h >= 12 && h < 24 ? 'pm' : 'am'; h = h % 12 || 12;
      return h + (m ? ':' + (m < 10 ? '0' : '') + m : '') + ap;
    }
    function today(s) {
      // stores are in Ontario, so "today" is Toronto's day, not the visitor's
      var wd = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: 'America/Toronto' }).format(new Date());
      var h = s.w[['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(wd)];
      if (!h) return T.closed;
      var p = h.split('-');
      return T.today + fmtTime(p[0]) + T.to + fmtTime(p[1]);
    }
    function pick(i, from) {
      var s = stores[i];
      pins.forEach(function (g) { g.classList.toggle('is-near', +g.getAttribute('data-i') === i); });
      var meta = s.a + ', ' + s.c;
      if (from) {
        var km = hav(from.lat, from.lng, s.lat, s.lng);
        km = km < 1 ? '<1' : Math.round(km);
        meta = from.name ? T.from(km, from.name) : T.away(km);
      }
      card.innerHTML = '<span class="vcsm__name">' + esc(s.n) + '</span><span class="vcsm__meta">' + esc(meta) + '</span>' +
        '<span class="vcsm__hours">' + esc(today(s)) + '</span><a href="' + esc(root + '/pages/' + s.h) + '">' + esc(T.link) + ' <i class="vce-arrow"></i></a>';
    }
    function nearest(lat, lng) {
      var best = 0, bd = Infinity;
      stores.forEach(function (s, i) { var d = hav(lat, lng, s.lat, s.lng); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    function press(btn) { chips.forEach(function (c) { c.setAttribute('aria-pressed', c === btn ? 'true' : 'false'); }); }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        press(c);
        var lat = +c.getAttribute('data-lat'), lng = +c.getAttribute('data-lng');
        pick(nearest(lat, lng), { lat: lat, lng: lng, name: c.textContent });
      });
    });
    var geo = sec.querySelector('[data-vcsm-geo]');
    if (geo) geo.addEventListener('click', function () {
      var fail = function () { card.innerHTML = '<p class="vcsm__hint">' + esc(sec.getAttribute('data-fail') || '') + '</p>'; };
      if (!navigator.geolocation) return fail();
      press(null);
      navigator.geolocation.getCurrentPosition(function (p) {
        pick(nearest(p.coords.latitude, p.coords.longitude), { lat: p.coords.latitude, lng: p.coords.longitude });
      }, fail, { timeout: 8000, maximumAge: 600000 });
    });

    var svg = sec.querySelector('.vcsm__svg');
    function showTip(g) {
      var s = stores[+g.getAttribute('data-i')], r = g.querySelector('.vcsm__dot').getBoundingClientRect(), m = map.getBoundingClientRect();
      tip.textContent = s.n;
      tip.style.left = (r.left + r.width / 2 - m.left) + 'px';
      tip.style.top = (r.top - m.top) + 'px';
      tip.style.opacity = 1;
    }
    svg.addEventListener('pointerover', function (e) { var g = e.target.closest('.vcsm__st'); if (g) showTip(g); });
    svg.addEventListener('pointerout', function (e) { if (e.target.closest('.vcsm__st')) tip.style.opacity = 0; });
    svg.addEventListener('click', function (e) {
      var g = e.target.closest('.vcsm__st');
      if (g) { press(null); pick(+g.getAttribute('data-i'), null); }
    });
  }

  /* ---------- rewards points slider ---------- */
  function initRewards(el) {
    if (el.__vc) return;
    el.__vc = true;
    var range = el.querySelector('.vcr-calc__range');
    if (!range) return;
    var fr = el.getAttribute('data-locale') === 'fr';
    var rate = +el.getAttribute('data-rate') || 5, rp = +el.getAttribute('data-rp') || 500, rv = +el.getAttribute('data-rv') || 3;
    var offT = el.getAttribute('data-off') || '[value] off', towardT = el.getAttribute('data-toward') || '[points] more points for [value] off';
    var amtEl = el.querySelector('[data-vcr-amt]'), ptsEl = el.querySelector('[data-vcr-pts]'), offEl = el.querySelector('[data-vcr-off]');
    var nf = new Intl.NumberFormat(fr ? 'fr-CA' : 'en-CA');
    var money = function (v) { return fr ? nf.format(v) + NBSP + '$' : '$' + nf.format(v); };
    var shown = +range.value * rate;
    function update(animate) {
      var amt = +range.value, pts = amt * rate, chunks = Math.floor(pts / rp);
      var off = chunks ? offT.replace('[value]', money(chunks * rv)) : towardT.replace('[points]', nf.format(rp - pts % rp)).replace('[value]', money(rv));
      if (amtEl) amtEl.textContent = money(amt);
      if (offEl) offEl.textContent = off;
      if (ptsEl) tween(animate ? shown : pts, pts, 350, function (v) { ptsEl.textContent = nf.format(Math.round(v)); });
      shown = pts;
      range.setAttribute('aria-valuetext', money(amt) + (fr ? NBSP + ': ' : ': ') + nf.format(pts) + ' points, ' + off);
    }
    range.addEventListener('input', function () { update(true); });
    update(false);
    onView(el, function () { el.classList.add('is-in'); });
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-vc-store-map]').forEach(initMap);
    root.querySelectorAll('[data-vc-rewards]').forEach(initRewards);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
